var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "like",
  "use": "like-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol viewBox=\"0 0 100 100\" id=\"like\">\n <g>\n  <path d=\"m83.332 44.793c0-2.918-2.293-5.207-5.207-5.207l-15.625-0.003907c-0.83203 0-3.75-1.25-1.457-4.793 1.457-2.707 1.457-12.918 1.457-12.918 0-2.9141-2.293-5.2031-5.207-5.2031-2.918 0-5.2109 2.2891-5.2109 5.207 0 15.207-14.582 19.793-14.582 19.793v27.082c6.668 2.293 8.332 6.25 16.668 6.25h15.625c2.918 0 5.207-2.293 5.207-5.207 0-1.25-0.41797-2.293-1.043-3.125 2.918 0 5.207-2.293 5.207-5.207 0-1.25-0.41797-2.5-1.25-3.543 2.082-0.83203 3.332-2.707 3.332-4.793 0-1.25-0.41797-2.5-1.25-3.543 1.8789-0.625 3.3359-2.5 3.3359-4.7891z\" />\n  <path d=\"m27.082 37.5h-10.414v35.418h10.418c3.543 0 6.25-2.918 6.25-6.25l-0.003907-22.918c0-3.543-2.707-6.25-6.25-6.25z\" />\n </g>\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/like.icon
// module id = 40
// module chunks = 168707334958949